import { createFileRoute } from '@tanstack/react-router';
import { GroupingRuleSetTypes } from '../../../../../../../../views/Settings/GroupingRules/types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/')({
  staticData: {
    groupingRuleType: GroupingRuleSetTypes.Violation_Tickets,
  },
});
